import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';
import { message } from 'antd';

import type { Picture } from 'app/redux/models/Picture/Picture';
import { apiRequest } from 'app/utils/request/api';

export const hotelPicturesPath = 'hotels/:hotelId/pictures' as const;

export function useHotelPictures(hotelId?: number) {
  return useQuery({
    queryKey: [hotelPicturesPath, { hotelId }],
    queryFn: hotelId
      ? () =>
          apiRequest({
            path: hotelPicturesPath,
            params: { hotelId: hotelId.toString() },
          }) as Promise<Picture[]>
      : undefined,
    enabled: !!hotelId,
    refetchOnWindowFocus: false,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    // Keep only official pictures, sorted by id (parité avec l'ancien state Redux).
    select: (pictures: Picture[]) =>
      pictures
        .filter((picture) => picture.kind === 'official')
        .sort((first, second) => first.id - second.id),
    onError: () => message.error('Error fetching Hotel Pictures'),
  });
}
